import { InfoIcon } from "@phosphor-icons/react/Info";
import { Callout } from "@freightsimple/ui-core/Display/Callout";
import { Icon } from "@freightsimple/ui-core/Icons/Icon";
import { Row } from "@freightsimple/ui-core/ComponentLayout/Row";
import { T } from "@freightsimple/ui-core/Typography/T";

interface LineItemsLimitReachedNoteProps {
  /** Which cap was reached and what to do instead, from `lineItemsAddLimit`. */
  explanation: string;
}

export function LineItemsLimitReachedNote(
  props: LineItemsLimitReachedNoteProps,
) {
  return (
    <div data-testid="line-items-limit-note">
      <Callout>
        <Row gap={2} align="start" shrinkable>
          <Icon icon={InfoIcon} weight="fill" color="text-blue" />
          <T size="sm" color="secondary">
            {props.explanation}
          </T>
        </Row>
      </Callout>
    </div>
  );
}
